import Box from "@mui/material/Box";
import { CenteredContent } from "../ui/CenteredContent";
import { Link } from "react-router-dom";
import { RouteNames } from "../router/RouteNames";
import EmailIcon from "@mui/icons-material/Email";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import SchoolIcon from "@mui/icons-material/School";
import { customColors } from "../util/Theme";
import profilePic from "../../assets/images/profile.jpg";

const iconStyle = { fontSize: 20, marginRight: "8px", verticalAlign: "middle" };

const BlueskyIcon = () => (
  <svg viewBox="0 0 568 501" style={{ width: 20, height: 20, marginRight: "8px", verticalAlign: "middle" }}>
    <path
      fill="currentColor"
      d="M123.121 33.664C188.241 82.553 258.281 181.68 284 234.873c25.719-53.192 95.759-152.32 160.879-201.21C491.866-1.611 568-28.906 568 57.947c0 17.346-9.945 145.713-15.778 166.555-20.275 72.453-94.155 90.933-159.875 79.748C507.222 323.8 536.444 388.56 473.333 453.32c-119.86 122.992-172.272-30.859-185.702-70.281-2.462-7.227-3.614-10.608-3.631-7.733-.017-2.875-1.169.506-3.631 7.733-13.43 39.422-65.842 193.273-185.702 70.281-63.111-64.76-33.889-129.52 80.986-149.071-65.72 11.185-139.6-7.295-159.875-79.748C10.945 203.659 1 75.291 1 57.946 1-28.906 76.134-1.612 123.121 33.664Z"
    />
  </svg>
);


export const AboutMeSite = () => {
  return (
    <CenteredContent>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "260px 1fr" },
          gap: { xs: "32px", md: "64px" },
          alignItems: "start",
        }}
      >
        {/* ===== LEFT SIDEBAR ===== */}
        <Box
          component="aside"
          sx={{
            borderRight: { xs: "none", md: `2px solid ${customColors.foreground}` },
            borderBottom: { xs: `2px solid ${customColors.foreground}`, md: "none" },
            paddingRight: { xs: 0, md: "32px" },
            paddingBottom: { xs: "32px", md: 0 },
            display: "flex",
            flexDirection: "column",
            alignItems: { xs: "center", md: "flex-start" },
            textAlign: { xs: "center", md: "left" },
          }}
        >
          {/* Profile photo */}
          <img
            src={profilePic}
            alt="Florian Chen"
            style={{
              width: "100%",
              maxWidth: "260px",
              aspectRatio: "1",
              objectFit: "cover",
              border: "2px solid #000000",
              marginBottom: "24px",
            }}
          />

          <h2 style={{ marginBottom: "8px" }}>
            Florian Chen
          </h2>

          <p style={{ marginBottom: "8px" }}>
            DPhil Student at Oxford
          </p>

          <nav>
            <ul
              style={{
                listStyle: "none",
                lineHeight: 2.4,
              }}
            >
              <li>
                <a
                  href="mailto:florian.chen@cs.ox.ac.uk" 
                  className="sidebar-link"
                >
                  <EmailIcon style={iconStyle} />
                  Email
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/florian-chen/"
                  className="sidebar-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedInIcon style={iconStyle} />
                  LinkedIn
                </a>
              </li>
              <li>
                <a
                  href="https://scholar.google.com/citations?user=R1g3S2YAAAAJ"
                  className="sidebar-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SchoolIcon style={iconStyle} />
                  Scholar
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/florian-chen"
                  className="sidebar-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <GitHubIcon style={iconStyle} />
                  GitHub
                </a>
              </li>
              <li>
                <a
                  href="https://bsky.app/profile/florianchen.bsky.social"
                  className="sidebar-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BlueskyIcon />
                  Bluesky
                </a>
              </li>
            </ul>
          </nav>
        </Box>

        {/* ===== RIGHT MAIN CONTENT ===== */}
        <main>
          <h1 style={{ marginBottom: "20px" }}>About Me</h1>
          <p style={{ marginBottom: "20px" }}>
            Hello kind stranger. I'm Florian and I'm a DPhil
            student in Computer Science at the{" "}
            <a
              href="https://www.ox.ac.uk/"
              target="_blank"
              rel="noopener noreferrer"
            >
              University of Oxford
            </a>
            , supervised by <a
              href="https://mvdw.uk/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mark van der Wilk
            </a>. 
            In my research, I am generally interested in theoretical foundations
            of machine learning.
            Currently, I am mainly working on understanding theoretical properties and 
            convergence guarantees of alternative learning algorithms for training deep neural networks.
          </p>
          <p style={{ marginBottom: "20px" }}>
            Previously, I completed my MSc in Advanced Computer Science at Oxford
            and my BSc in Software & Information
            Engineering at{" "}
            <a
              href="https://www.tuwien.at/"
              target="_blank"
              rel="noopener noreferrer"
            >
              TU Wien
            </a>
            , where I was advised by{" "}
            <a
              href="https://thomasgaertner.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Thomas G&auml;rtner
            </a>
              {" "}and{" "}
            <a
              href="https://neumannstefan.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}Stefan Neumann
            </a>
            .
          </p>
          <p style={{ marginBottom: "30px" }}>
            Outside of my studies, I enjoy playing video games, reading science fiction, and{" "}
            <Link
              to={RouteNames.TRAVEL}
            >
              travelling
            </Link>.
          </p>

          <h2 style={{ marginBottom: "16px" }}>News</h2>
          <ul
            style={{
              listStyleType: "disc",
              paddingLeft: "20px",
              marginBottom: "30px",
            }}
          >
            <li style={{ marginBottom: "12px" }}>
              (October 2026) Started my DPhil in Computer Science at Oxford. Finished my MSc in Advanced Computer Science with Distinction.
            </li>
            <li style={{ marginBottom: "12px" }}>
              (September 2026) Workshop paper at MLG@ECML-PKDD 2026: In <i>On the Best Interval Approximation Problem</i> we provide extended theory and practical methods for discovering opinion intervals in social networks.
            </li>
            <li style={{ marginBottom: "12px" }}>
              (December 2025) Oral at NeurIPS 2025: In <i>Discovering Opinion Intervals from Conflicts in Signed Graphs</i> we study how to discover the opinions of individuals from their interactions in social networks.
            </li>
            <li style={{ marginBottom: "12px" }}>
              (October 2025) Started my MSc in Advanced Computer Science at Oxford.
            </li>
            <li style={{ marginBottom: "12px" }}>
              (August 2025) Graduated from TU Wien with a Bachelor with Honors in Software & Information Engineering.
            </li>
            <li style={{ marginBottom: "12px" }}>
              (September 2024) Two papers at ECML-PKDD 2024: Check out <i>Understanding Domain-Size Generalization in Markov Logic Networks</i> to train statistical relational learning models that generalize to larger domain sizes, and <i>Scalable Interactive Data Visualization</i> for low-dimensional embeddings that allow smooth interaction.
            </li>
          </ul>

          <h2 style={{marginBottom: "16px"}} >Publications</h2>
          <div>
            <p style={{ marginBottom: "20px" }}>
              Peter Blohm*, <strong>Florian Chen*</strong>, Aristides Gionis,
              Stefan Neumann. <br />
              <a href="https://mlg-europe.github.io/2026/submissions/389/Submission/389%20blohm%20Opinion_Projection-CR.pdf">
                On the Best Interval Approximation Problem
              </a>
              .
              <br />
              In <em>MLG@ECML-PKDD</em> 2026 (oral presentation).{" "}
              [<a href="/files/MLG-BIA-Poster.pdf">Poster</a>]{" "}
              [<a href="/files/Discovering_Opinion_Intervals_ECML-1.pdf">Slides</a>]{" "}
              [<a href="https://github.com/Peter-Blohm/discovering_opinion_intervals/tree/kernelisation">Code</a>]
            </p>

            <p style={{ marginBottom: "20px" }}>
              Peter Blohm*, <strong>Florian Chen*</strong>, Aristides Gionis,
              Stefan Neumann. <br />
              <a href="https://openreview.net/forum?id=zJdutIT6vT">
                Discovering Opinion Intervals from Conflicts in Signed Graphs
              </a>
              .
              <br />
              In <em>NeurIPS</em> 2025 (oral presentation).{" "}
              [<a href="/files/NeurIPS_Poster.pdf">Poster</a>]{" "}
              [<a href="/files/Discovering_Opinion_Intervals_Oral.pdf">Slides</a>]{" "}
              [<a href="https://github.com/Peter-Blohm/discovering_opinion_intervals">Code</a>]
              [<a href="https://neurips.cc/virtual/2025/loc/san-diego/oral/115063">Talk</a>]
            </p>

            <p style={{ marginBottom: "20px" }}>
              <strong>Florian Chen</strong>, Felix Weitk&auml;mper, Sagar
              Malhotra. <br />
              <a href="https://link.springer.com/chapter/10.1007/978-3-031-70368-3_18">
                Understanding Domain-Size Generalization in Markov Logic
                Networks
              </a>
              .
              <br />
              In <em>ECML-PKDD</em> 2024.{" "}
              [<a href="/files/1186_Poster_topdown_3.pdf">Poster</a>]{" "}
              [<a href="/files/Understanding_Domain_Size_Generalization_in_Markov_Logic_Networks.pdf">Slides</a>]{" "}
              [<a href="https://github.com/faguodev/regularization_experiments">Code</a>]
            </p>
            <p style={{ marginBottom: "20px" }}>
              <strong>Florian Chen</strong>, Thomas G&auml;rtner. <br />
              <a href="https://link.springer.com/chapter/10.1007/978-3-031-70371-3_34">
                Scalable Interactive Data Visualization
              </a>
              .
              <br />
              In <em>ECML-PKDD</em> 2024.{" "}
              [<a href="/files/1568_Poster_design2_right.pdf">Poster</a>]{" "}
              [<a href="https://github.com/faguodev/invis">Code</a>]{" "}
              [<Link to={RouteNames.INVIS_DEMO}>Demo</Link>]
            </p>
          </div>
        </main>
      </Box>
    </CenteredContent>
  );
};
